/**
 * @generated SignedSource<<edbf8c65741e5d008d81cafa305c3fdd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PostAccessRecipientStatusEnum = "ACTIVE" | "EXPIRED" | "REVOKED";
export type UpdatePostAccessRecipientInput = {
  authorId?: string | null | undefined;
  created?: string | null | undefined;
  domain?: string | null | undefined;
  email?: string | null | undefined;
  expiresAt?: string | null | undefined;
  id: string;
  modified?: string | null | undefined;
  postId?: string | null | undefined;
  status?: PostAccessRecipientStatusEnum | null | undefined;
  type?: string | null | undefined;
};
export type Utils_UpdatePostAccessRecipient_Mutation$variables = {
  input: UpdatePostAccessRecipientInput;
};
export type Utils_UpdatePostAccessRecipient_Mutation$data = {
  readonly updatePostAccessRecipient: {
    readonly postAccessRecipient: {
      readonly created: string | null | undefined;
      readonly domain: string;
      readonly email: string;
      readonly expiresAt: string | null | undefined;
      readonly id: string;
      readonly modified: string | null | undefined;
      readonly status: PostAccessRecipientStatusEnum;
    } | null | undefined;
  } | null | undefined;
};
export type Utils_UpdatePostAccessRecipient_Mutation = {
  response: Utils_UpdatePostAccessRecipient_Mutation$data;
  variables: Utils_UpdatePostAccessRecipient_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdatePostAccessRecipientPayload",
    "kind": "LinkedField",
    "name": "updatePostAccessRecipient",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PostAccessRecipient",
        "kind": "LinkedField",
        "name": "postAccessRecipient",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "domain",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expiresAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "created",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "modified",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Utils_UpdatePostAccessRecipient_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Utils_UpdatePostAccessRecipient_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "897566cefbd84cb1de4ef573f743c901",
    "id": null,
    "metadata": {},
    "name": "Utils_UpdatePostAccessRecipient_Mutation",
    "operationKind": "mutation",
    "text": "mutation Utils_UpdatePostAccessRecipient_Mutation(\n  $input: UpdatePostAccessRecipientInput!\n) {\n  updatePostAccessRecipient(input: $input) {\n    postAccessRecipient {\n      id\n      email\n      domain\n      status\n      expiresAt\n      created\n      modified\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6af86df3fc2640740c3d8127bda27149";

export default node;
